const checkItemByCinemasArray = (item, cinemaIds, cinemasAttr = 'cinemaIds') => {
    const itemCinemaIds = item[cinemasAttr]

    const check = cinemaIds && cinemaIds.reduce(
        (accumulator, current) => accumulator && itemCinemaIds && itemCinemaIds.includes(current),
        true
    )

    return check
}

export default checkItemByCinemasArray
